export default __webpack_public_path__ + "locales/nl/ChangeUserTypeDialog.json?hash=7fe3407e455035baa7561e0481cae12e";